// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3xyj5","content":"GlobalSearch_content__32I_L"};